import React from 'react';
import { cn } from '../../lib/utils';

const Separator = React.forwardRef(({ className, orientation = 'horizontal', ...props }, ref) => (
  <div
    ref={ref}
    role="separator"
    aria-orientation={orientation}
    className={cn(
      orientation === 'horizontal' ? 'h-px w-full bg-pearl-200' : 'h-full w-px bg-pearl-200',
      className
    )}
    {...props}
  />
));

Separator.displayName = 'Separator';

export { Separator };
